<style lang="scss">
.component__view-pack {
  width: 280px;

  display: inline-block;
  outline: 1px dashed rgba(45, 45, 48, .2);
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  user-select: none;
  position: relative;

  &:hover {
    outline: 0;
    /*border-color: orangered;*/
  }

  .info-table {
    tr {
      td {
        &:first-child {
          color: gray;
        }
      }
    }
  }

  &:hover {
    .overlay-dblclick-for-detail {
      display: flex;
    }
  }

  .overlay-dblclick-for-detail {
    position: absolute;
    display: none;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(45, 45, 48, .5);
    color: white;

    align-items: center !important;

    div {
      width: 100%;
      color: white;
      text-align: center;
      justify-content: center;
      justify-items: center;

    }
  }
}
</style>
<template>
  <div class="component__view-pack" @dblclick="view_pack_show=true">
    <table style="width:100%;">
      <tbody>
      <tr>
        <td>
          <div
            style="width:40px; height: 40px; padding:2px; border-radius:50vh; background:linear-gradient(to bottom right,#FF0080,#ED12C1)">
            <img
              src="static/img/logo.png"
              alt="pack_logo"
              style="padding:3px; border-radius: 50vh; max-width: 100%; background-color:white;">
          </div>
        </td>
        <td>
          <div style="color: orangered; max-width: 230px; overflow: hidden; text-overflow: ellipsis; font-size: 13px;">
            {{ pack_info.name }} <span
            style="color:green; font-weight: 600">[{{
              /*(pack_info.price / 1000) === 0 ? 'Dùng thử' : `${VND(pack_info.price / 1000)}K`*/
              pack_info.default_for_free ? 'Dùng thử' : `${VND(pack_info.price / 1000)}K`
            }}]</span>
          </div>
          <div
            style="color:gray; height:20px; font-style: italic; max-width: 230px; overflow: hidden; text-overflow: ellipsis;">
            {{ pack_info.description }}
          </div>
          <div v-if="is_apply">
            <!--            <div>Gói áp dụng cho x1 tháng</div>-->
            <div>Số lượng gói: {{ pack_info.count }}</div>
          </div>
          <div v-else style="color:gray; font-size: 13px; font-weight: 600" v-if="license_to.length>0">
            Bản quyền đến:
            <span v-bind:class="{'text-danger': m__check_is_expr()}"
                  style="font-size: 13px; font-weight: bold">{{ license_to | timeFormat }}</span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="overlay-dblclick-for-detail">
      <div>
        Nhấn đúp để {{ $t('base.see_detail') }}
      </div>
    </div>
    <el-dialog :visible.sync="view_pack_show" width="400px" :close-on-click-modal="false" custom-class="no-body">
      <div slot="title" style="padding:10px;">
        <table class="table table-hover info-table" style="margin-top:10px;">
          <thead>
          <tr>
            <th>Thuộc tính</th>
            <th>Giá trị</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>Tên gói</td>
            <td style="color: orangered;">{{ pack_info.name }}</td>
          </tr>
          <tr>
            <td>Mô tả</td>
            <td>{{ pack_info.description }}</td>
          </tr>
          <tr>
            <td>Giá gói</td>
            <td>
                            <span style="color: orangered;">
                                {{ pack_info.price !== 0 ? VND(pack_info.price) : 'Miễn phí' }}
                            </span>
            </td>
          </tr>
          <tr>
            <td>Shop kết nối</td>
            <td>{{ pack_info.shop_connect | currency }}</td>
          </tr>
          <template v-if="channel.includes('shopee')">
            <tr>
              <td>Công cụ từ khóa</td>
              <td>
                <i v-if="m__check_pack_marketing('keyword_tool')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Phân tích Insight</td>
              <td>
                <i v-if="m__check_pack_marketing('order_center')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Ngân sách tự động</td>
              <td>
                <i v-if="m__check_pack_marketing('auto_campaign')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Chống click ảo</td>
              <td>
                <i v-if="m__check_pack_marketing('anti_click')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Tối ưu theo điều kiện</td>
              <td>
                <i v-if="m__check_pack_marketing('delete_keyword')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Tối ưu theo CIR</td>
              <td>
                <i v-if="m__check_pack_marketing('auto_cir')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <!--            <tr>-->
            <!--              <td>Kiểm tra vị trí Ads</td>-->
            <!--              <td>-->
            <!--                <i v-if="m__check_pack_marketing('check_ads_position')"-->
            <!--                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>-->
            <!--                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>-->
            <!--              </td>-->
            <!--            </tr>-->
            <tr>
              <td>Đấu thầu theo vị trí Trung Bình</td>
              <td>
                <i v-if="m__check_pack_marketing('check_ads_position')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr
              v-if="!m__check_pack_marketing('check_ads_position') && m__check_pack_marketing('auto_campaign')">
              <td>Đấu thầu theo vị trí Trung bình</td>
              <td>
                <i
                  v-if="!m__check_pack_marketing('check_ads_position') && m__check_pack_marketing('auto_campaign')"
                  style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Flash sale nâng cao</td>
              <td>
                <i v-if="m__check_pack_marketing('flash_sale_advanced')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Kế hoạch quảng cáo</td>
              <td>
                <i v-if="m__check_pack_marketing('agency_plan')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Spy vị trí Ads</td>
              <td>
                <i v-if="m__check_pack_marketing('spoil_ads')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
            <tr>
              <td>Shopee Trend</td>
              <td>
                <i v-if="m__check_pack_marketing('spoil_ads')"
                   style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
                <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr>
              <td>Đơn hàng</td>
              <td>{{ pack_info.order | currency }}</td>
            </tr>
            <tr>
              <td>Sao chép sản phẩm</td>
              <td>{{ pack_info.copy_product | currency }}</td>
            </tr>
            <tr>
              <td>Taffic mỗi (giây)</td>
              <td>{{ pack_info.interval_traffic | currency }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
//import dayjs from 'dayjs'

export default {
  name: 'component__pack-viewer',
  props: {
    pack_info: {
      type: Object,
      default: {}
    },
    license_to: {
      type: String
    },
    channel: {
      type: String,
      default: 'Shopee'
    },
    is_apply: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      view_pack_show: false
    }
  },
  beforeMount () {

  },
  methods: {
    m__check_pack_marketing (field) {
      return this.pack_info.extra_data && this.pack_info.extra_data.marketing && this.pack_info.extra_data.marketing[field]
    },

    m__check_is_expr () {
      return this.dayjs().isSameOrAfter(new Date(this.license_to), 's')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/package/pack_viewer.vue